export default "__VITE_ASSET__yB0GEGyL__"